import { useQuery } from '@tanstack/react-query';
import { orgApi } from '@/api/org';
import { queryKeys } from '@/query/queryKeys';

const useOrgHolidaysQuery = (enabled: boolean) =>
  useQuery({
    queryKey: queryKeys.orgHolidays(),
    queryFn: () => orgApi.listHolidays(),
    enabled,
  });

const useOrgWideEventsQuery = (enabled: boolean, range?: { from: string; to: string }) =>
  useQuery({
    queryKey: queryKeys.orgWideEvents(range),
    queryFn: () => orgApi.listWideEvents(range),
    enabled,
  });

const useOrgScheduleQuery = () =>
  useQuery({
    queryKey: queryKeys.orgSchedule(),
    queryFn: () => orgApi.getSchedule(),
  });

export { useOrgHolidaysQuery, useOrgWideEventsQuery, useOrgScheduleQuery };
